import React from 'react';
import cx from 'classnames';
var ALERT_BOTTOM_MARGIN = 32;
var ALERT_ACTION_SHEET_MARGIN = 16;
export var MinimalNotificationsContainer = function (_a) {
    var _b;
    var children = _a.children;
    var componentClass = 'minimal-notifications-container';
    var actionSheetHeight = (_b = document.querySelector('.action-sheet')) === null || _b === void 0 ? void 0 : _b.clientHeight;
    var marginBottomPx = actionSheetHeight
        ? actionSheetHeight + ALERT_ACTION_SHEET_MARGIN
        : ALERT_BOTTOM_MARGIN;
    var marginBottom = "".concat(marginBottomPx, "px");
    return (React.createElement("div", { className: cx('fixed-bottom', 'd-flex', 'flex-column', 'align-items-center', componentClass), style: { marginBottom: marginBottom } }, children));
};
//# sourceMappingURL=MinimalNotificationsContainer.js.map